import React, { createContext, useContext, useEffect, useState } from 'react';
import { apiContext, clearAuthSession } from '../../../Api';
export const userContext = createContext()
function Profile(props) {
    const {axios} = useContext(apiContext)
    const [user, setUser] = useState(false);
    const [ready, setReady] = useState(false);
    const profile = async () => {
        try {
            const res = await axios.get('/biodata');
            setUser(res.data);
        } catch (error) {
            const status = error?.response?.status;

            if (status === 401 || status === 419) {
                clearAuthSession();
            }

            setUser(false);
        } finally {
            setReady(true);
        }
    }
    useEffect(() => {
        const token = localStorage.getItem('token');
       
        if (token) {
            profile();
            return;
        }
        setReady(true);
    }, [])

    return ready && user ? (
        <userContext.Provider
            value={{
                user,profile
            }}>
            {props.children}
        </userContext.Provider>
    ) : ready ? props.children : ''
}
export default Profile;
